import { useLanguageStore } from "@/providers/useLanguageStore";
import React from "react";

const ContactAddress = () => {
  const { translations } = useLanguageStore();

  return (
    <div className="px-4 md:px-16">
      <p className="mx-auto  text-xl lg:text-2xl font-bold text-black font-archivo mb-2 flex flex-col md:flex-row ">
        {translations.locationTitle || "Nos encontramos en"}
        <span className="text-red-600 md:ms-2">
          {translations.locationAddress || "Gral Paz 576, Tuc, Arg"}
        </span>
      </p>
      <div className="relative p-5 bg-black">
        <div className="absolute inset-0 grid grid-cols-12 grid-rows-12">
          <div className="col-start-1 col-end-1 row-start-12 row-end-13 bg-red-600"></div>
          <div className="col-start-1 col-end-1 row-start-7 row-end-11 bg-red-600 opacity-70"></div>
          <div className="col-start-12 col-end-12 row-start-1 row-end-2 bg-red-600"></div>
          <div className="col-start-12 col-end-12 row-start-3 row-end-7 bg-red-600 opacity-70"></div>
        </div>
        <div className="relative z-10 flex justify-center">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3560.1060679494653!2d-65.20974192483746!3d-26.836578490026564!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94225d3ad7f30f1d%3A0xf8606cd659b8e3e4!2sRollingCode%20School!5e0!3m2!1ses!2sar!4v1736520879778!5m2!1ses!2sar"
            width="100%"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            className="shadow-lg h-[300px] md:h-[350px] lg:h-[410px] xl:h-[450px]"
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default ContactAddress;
